import { type DataColumn } from "@features/mmm/components/explore-budgets/client-setting/types";
import { useNorthbeamLazyQuery } from "@hooks/http";
import {
  type FetchCycleDataColumnsV2,
  type FetchCycleDataColumnsV2Variables,
} from "@north-beam/nb-client-side";

import { MMM_CYCLE_DATA_COLUMNS_V2_QUERY } from "../explore-budgets-v2/explore-budgets-queries";

import { useClientDataColumns } from "./use-client-data-columns";

export const useAvailableDataColumns = () => {
  const { setClientDataColumns, setClientLegacyDataColumns } =
    useClientDataColumns();

  const {
    loadData: loadDataColumns,
    data: { loading: isLoadingDataColumns },
  } = useNorthbeamLazyQuery<
    FetchCycleDataColumnsV2,
    FetchCycleDataColumnsV2Variables
  >(MMM_CYCLE_DATA_COLUMNS_V2_QUERY, {
    onCompleted: (data) => {
      const { availableDataColumns } = data.me.mmm;

      if (availableDataColumns.legacyDataColumns?.length) {
        setClientLegacyDataColumns(
          availableDataColumns.legacyDataColumns as unknown as DataColumn[],
        );
      }

      if (availableDataColumns.dataColumns?.length) {
        setClientDataColumns(
          availableDataColumns.dataColumns as unknown as DataColumn[],
        );
        return;
      }
    },
  });

  return { loadDataColumns, isLoadingDataColumns };
};
